import React, { FC, useEffect, useRef } from 'react'
import Modal from 'react-modal'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import { useRouter } from 'next/router'
import PerfectScrollbar from 'react-perfect-scrollbar'

const QuizModal: FC<{ open: boolean }> = ({ open, children }) => {
  const ref = useRef(null)
  const router = useRouter()

  useEffect(() => {
    clearAllBodyScrollLocks(ref)
  }, [router.asPath])

  useEffect(() => {
    open ? disableBodyScroll(ref) : clearAllBodyScrollLocks(ref)
  }, [open])

  return (
    <Modal
      isOpen={open}
      ref={ref}
      style={{
        content: {
          padding: 0,
          inset: 0,
          border: 0,
          zIndex: 10,
          borderRadius: null,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          display: 'flex',
          flexDirection: 'column',
        },
        overlay: { zIndex: 10 },
      }}
    >
      <PerfectScrollbar options={{ swipeEasing: true }}>
        {children}
      </PerfectScrollbar>
    </Modal>
  )
}

export default QuizModal
